// extracted by mini-css-extract-plugin
export var button = "_mb-0";